module.exports = __webpack_public_path__ + "img/detail_D10D.c8104e41.png";